import { OdataManager } from '@/api/odata/odata-manager';
import { AgreementSettings, SettingData } from '@/store/settings/types';

export default class AgreementSettingsOdata extends OdataManager<AgreementSettings | SettingData> {}
